import { ManualTask } from '../../../types'
import { useMemo } from 'react'
import { manualReviewTasks } from 'Automations/nodeDefinitions/nodeDefinitions'

export const ManualTaskItem = ({
  manualTask,
  isSelected,
  hideUnreadIndicator,
  onClick
}: {
  manualTask: ManualTask
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const ListItem = useMemo(() => {
    return manualReviewTasks[manualTask.type]?.listItemContent
  }, [manualTask])

  if (!ListItem) {
    return null
  }

  return (
    <ListItem
      taskId={manualTask.id}
      isSelected={isSelected}
      hideUnreadIndicator={hideUnreadIndicator}
      onClick={onClick}
    />
  )
}
